const restitutionTypes = [
  {
    id: 1,
    type: 'Diagramme en secteur - simple',
  },
  {
    id: 2,
    type: 'Diagramme en secteur',
  },
  {
    id: 3,
    type: 'Diagramme horizontal',
  },
  {
    id: 4,
    type: 'Seuils et intervalles',
  },
  {
    id: 5,
    type: 'Score plein',
  },
  {
    id: 6,
    type: 'Diagramme araignée',
  },
];

export { restitutionTypes };
